//#region Types
import { WintSuperkollAPIModelAnnualAccounts } from "wint-api-client/dist/types";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

export const useResponsibleText = () => {
  return (responsible: WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson) => {
    return LocalizationHelperInstance.getTranslatedEnumValue(
      "Accounting.TimeLineStepResponsiblePerson",
      WintSuperkollAPIModelAnnualAccounts.AnnualReportTimeLineStepResponsiblePerson[responsible].toString()
    );
  };
};
